import { Predicate } from './types';

export function errmsg(value: unknown): string {
  const result = JSON.stringify(value, (_, value) => (value === undefined ? 'undefined' : value));
  if (result.length > 128) {
    return `${result.slice(0, 128)}...`;
  }
  return result;
}

export function simpleInfo(predicate: Predicate, value: unknown) {
  return `${errmsg(value)} is not ${predicate.name}`;
}

export function conditionInfo(condition: string, value: unknown, threshold: number) {
  return `${errmsg(value)} is not ${condition} than ${threshold}`;
}
